'use strict';

var $truncateTexts = $('.js-truncate-text');
var truncAttr = 'trunc-amount';

$truncateTexts.each(function () {
  var elem = this;
  var truncBy = $(elem).attr(truncAttr) || 330;
  var origStr = $(elem).html();
  var newStr = truncate(origStr, truncBy, true);

  if (origStr !== newStr) {
    $(elem).html(newStr);
    $(elem).append('<button class="btn-link btn-inline">meer</button>');

    $('.btn-link', elem).on('click', function () {
      $(elem).html(origStr);
    });
  }
});

function truncate(str, n, useWordBoundary) {
  if (str.length <= n) {
    return str;
  }
  const subString = str.substr(0, n - 1);
  return (useWordBoundary
    ? subString.substr(0, subString.lastIndexOf(" "))
    : subString) + "&hellip;";
};
